<template>
  <div>
    <NavEN/>
    <div class="main-container">
      <section class="middle-image">
        <img src="../../../public/img/background-contact.jpg">
      </section>
      <section class="large-contract">
        <div class="contract-left">
          <div class="under-line"></div>
          <h4>Get in touch today</h4>
          <p>Send us any question, or ask if we can help solve any problems for you.</p>
        </div>
        <div class="contract-right">
          <div class="email-box">
            <img src="../../assets/Email.svg">
            <span>
              <h5>[E-mail]:</h5>
              <p>18618429755@163.com</p>
            </span>
          </div>
          <div class="contract-box">
            <h5>[Address]:</h5>
            <p>Room 1605-16F, 32 Weisi Road East, Jinshui District, Zhengzhou City, Henan Province, P. R.China</p>
            <h5>[Tel.]:</h5>
            <p>
              0371-86153190<br>
              0371-63737206<br>
              18539253199
            </p>
            <h5>[Fax]:</h5>
            <p>0371-63737012</p>
            <a  class="btn-message" href="mailto:18618429755@163.com">Sends Message</a>
          </div>
        </div>
      </section>
    </div>
    <FooterEN/>
  </div>
</template>

<script>
import NavEN from '@/components/nav-en.vue'
import FooterEN from '@/components/footer-en.vue'

export default {
  name: 'contractEN',
  components: {
    NavEN,
    FooterEN
  }
}
</script>

<style lang="scss">
  .main-container {
    max-width: 1580px;
    margin: 0 auto;
    .middle-image {
      background: #333;
      width: 100%;
      height: 100%;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
        opacity: .7;
      }
    }
    .large-contract {
      position: relative;
      margin: 0 auto;
      padding-top: 20px;
      @media(min-width: 768px) {
        display: flex;
        width: 750px;
        margin-bottom: 20px;
      }
      @media(min-width: 992px) {
        display: flex;
        width: 970px;
      }
      @media(min-width: 1200px) {
        display: flex;
        width: 1170px;
      }
      .contract-left {
        width: 70%;
        padding: 0 15px;
        margin: 0 auto;
        @media(min-width: 768px) {
          width: 50%;
        }
        @media(min-width: 992px) {
          width: 35%;
        }
        .under-line {
          width: 40px;
          height: 2px;
          background: #02328d;
          margin-bottom: 20px;
        }
        h4 {
          margin-bottom: 50px;
          font-size: 24px;
          font-weight: 300;
          line-height: 32px;
          text-align: left;
          color: rgb(51, 51, 51);
        }
        p {
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          text-align: left;
          color: rgb(119, 119, 119);
        }
      }
      .contract-right {
        width: 70%;
        padding: 0 15px;
        margin: 0 auto;
        align-items: center;
        @media(min-width: 768px) {
          width: 50%;
        }
        @media(min-width: 992px) {
          display: flex;
          width: 65%;
        }
        .email-box {
          width: 100%;
          padding: 0 15px;
          @media(min-width: 992px) {
            width: 50%;
          }
          img {
            display: none;
            width: 40px;
            height: 40px;
            margin-right: 20px;
            transform: translateY(-20%);
            @media(min-width: 992px) {
              display: inline-block;
            }
          }
          span {
            display: block;
            @media(min-width: 992px) {
              display: inline-block;
            }
            h5 {
              margin-top: 0;
              margin-bottom: 10px;
              font-size: 20px;
              font-weight: 600;
              line-height: 28px;
              text-align: left;
              color: rgb(51, 51, 51);
            }
            p {
              font-size: 14px;
              font-weight: 400;
              line-height: 24px;
              text-align: left;
              color: rgb(119, 119, 119);
            }
          }
        }
        .contract-box {
          position: relative;
          width: 100%;
          padding: 0 15px;
          @media(min-width: 992px) {
            width: 50%;
          }
          h5 {
            margin-bottom: 10px;
            font-size: 20px;
            font-weight: 600;
            line-height: 28px;
            text-align: left;
            color: rgb(51, 51, 51);
          }
          p {
            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            text-align: left;
            color: rgb(119, 119, 119);
          }
          .btn-message {
            display: inline-block;
            border: #337ab7 solid 2px;
            padding: 8px 16px;
            font-size: 12px;
            font-weight: 700;
            text-transform: uppercase;
            text-decoration-line: none;
            line-height: 1.5;
            color: #337ab7;
            &:hover {
              background-color: #337ab7;
              color: white;
              opacity: .7;
            }
          }
        }
      }
    }
  }
</style>
